import { render, staticRenderFns } from "./ImageElement.vue?vue&type=template&id=48bacdb2&scoped=true"
import script from "./ImageElement.vue?vue&type=script&lang=js"
export * from "./ImageElement.vue?vue&type=script&lang=js"
import style0 from "./ImageElement.vue?vue&type=style&index=0&id=48bacdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bacdb2",
  null
  
)

export default component.exports